import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchStudentcheduledMeetings } from "../../../services/student";
import { reactToast } from "../../../helper";

export const getStudentMeetings = createAsyncThunk(
  "data/studentMeetings",
  async ({ studentId, startDate, endDate }) => {
    try {
      const { status, data } = await fetchStudentcheduledMeetings(
        studentId,
        startDate,
        endDate
      );

      if (status === 200) {
        if (data?.data?.length) {
          return data?.data;
        } else {
          return [];
        }
      } else {
        reactToast("error", data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);
